import * as React from "react";
import './App.css';
import Messages from "./Messages";
import Input from "./Input";
import Users from "./Users";
import * as Types from "./Types";
import 'whatwg-fetch';

const wsUrl = "wss://iot.alterozoom.com/ws";
//const wsUrl = "wss://ecoimpact-ple.com/ws";
//const wsUrl:string = "ws://localhost:3003/";

function parseMessage(string) {
    try {
        return JSON.parse(string);
    } catch(e) {
        return null;
    }
}

function initializeWebsocketConnection(socket:WebSocket,appComponent:App) {
    socket.onmessage = appComponent.wsOnMessage.bind(appComponent);
    socket.onclose = appComponent.wsOnClose.bind(appComponent);
    socket.onerror = appComponent.wsOnError.bind(appComponent);
    socket.onopen = appComponent.wsOnOpen.bind(appComponent);
    appComponent.state.connection.socket = socket;
}

let documentId:number|null = null;

class App extends React.Component<any,Types.AppState> {
    public readonly state: Types.AppState = {
        messages: [],
        users: [],
        documentId: undefined,
        documentTitle: undefined,
        connection : {
            connectionState: Types.ConnectionState.Init,
            connectionId: null,
            socket: null
        }
    }    
    constructor(props) {
        super(props);
        const urlSegments = window.location.href.split("/");
        const lastSegment = urlSegments[urlSegments.length - 1];
        const documentId = parseInt(lastSegment);
        if(documentId) {
            this.state.documentId = documentId;
            const socket = new WebSocket(wsUrl);
            if(socket) {
                initializeWebsocketConnection(socket,this);
                fetch("/documents/"+documentId+".json",{credentials: "same-origin"})
                    .then((response) => response.json())
                    .then((documentInfo) =>  {
                        document.title = documentInfo.title;
                        this.setState({documentTitle:documentInfo.title});                        
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                fetch("/user_info.json",{credentials: "same-origin"})
                    .then((response) => response.json())
                    .then((userInfo:Types.User) => this.setState({currentUser:userInfo}))
                    .catch(error => {
                        console.log(error);
                        alert('Server error. Please try again later.');
                    });
            } else {
                console.log("Cannot create WebSocket.");
                this.state.connection.connectionState = Types.ConnectionState.Error;
            }
        } else {
            console.log("Unknown document id");
            this.state.connection.connectionState = Types.ConnectionState.Error;
        }
    }
    wsOnMessage(event:any) {
        console.log(event);
        const socket = this.state.connection.socket;
        const mes = parseMessage(event.data);
        if(this.state.connection.connectionState === Types.ConnectionState.WaitingForId) {
            if(mes.type === "ConnectionAccepted") {
                this.state.connection.connectionId = mes.id;
                this.state.connection.connectionState = Types.ConnectionState.Connected;
                const subscribedMessage = {
                    type: 'Subscribed',
                    documentId: this.state.documentId,
                    id:mes.id
                };
                if(socket) {
                    try {
                        socket.send(JSON.stringify(subscribedMessage));
                    } catch (error) {
                        console.log(error);
                    }
                }
            } else  {
                console.log('Unexpected message');
                console.log("wsConnectionState: "+this.state.connection.connectionState);
                console.log(mes);
            }
        } else if (this.state.connection.connectionState === Types.ConnectionState.Connected) {
            if(mes.type === "NewTextMessageReceived") {
                this.setState(state => {
                    mes.createdAt = new Date(mes.createdAt);
                    state.messages.push(mes);
                    return state;
                });
                if(this.state.currentUser) {
                    if(Notification
                       && Notification.permission !== 'denied'
                       && mes.senderId !== this.state.currentUser.id) {
                        new Notification('New message', {
                            body: mes.text
                        });
                    }
                }
            } else if(mes.type === "FoundDuplicate") {
                console.log("documents.already_opened");
            } else if (mes.type === "OldTextMessages") {
                this.setState(state => {
                    //@ts-ignore    
                    state.messages = mes.messages
                                        .map((m)=>{m.createdAt = new Date(m.createdAt);return m;})
                                        .sort((a,b)=>{return (a.createdAt - b.createdAt)});
                    
                    //@ts-ignore
                    state.users = mes.users;
                    return state;
                });
                this.grantNotificationPermission();
            } else {
                console.log('Unexpected message');
                console.log("wsConnectionState: "+this.state.connection.connectionState);
                console.log(mes);
            }
        }
    }
    wsOnClose(event:any) {
        console.log("WebSocket connection closed");
        console.log(event);
        const message = parseMessage(event.reason);
        if(message && message.type === "NotAuthorized") {
            this.setState(state => {
                state.connection.connectionState = Types.ConnectionState.NotAuthorized;
                return state;
            });
            console.log("NotAuthorized");            
        } else {            
            this.state.connection.socket = null;
            this.reconnect();
        }
    }
    wsOnOpen(event:any) {        
        this.state.connection.connectionState = Types.ConnectionState.WaitingForId;
    }
    wsOnError(event:any) {
        console.log("WebSocket error:");
        console.log(event);
    }
    deleteMessage(messageId) {
        const confirm = window.confirm("Are you sure want to delete this message?");
        if(confirm) {
            this.setState(state => {
                //@ts-ignore
                state.messages = state.messages.filter((mes)=> mes.id !== messageId);
                return state;
            });
            const socket = this.state.connection.socket;
            const deleteMessage = {
                type: "DeleteMessage",
                id: messageId,
                documentId: this.state.documentId
            };
            if(socket) {
                try {
                    socket.send(JSON.stringify(deleteMessage));
                } catch (error) {
                    console.log(error);
                }
            }
        }    
    }
    grantNotificationPermission () {
        if (!('Notification' in window)) {
            console.log('This browser does not support system notifications');
            return;
        }

        if (Notification.permission === 'granted') {
            console.log('You are already subscribed to message notifications');
            //new Notification('You are already subscribed to message notifications');
            return;
        }
                
        if (
            Notification.permission !== 'denied' ||
            //@ts-ignore
            Notification.permission === 'default'
        ) {
            Notification.requestPermission().then(result => {
                if (result === 'granted') {                    
                   console.log('You will start receiving notifications shortly');
                }
            });
        }
    }
    render() {
        let content;
        if(this.state.connection.connectionState === Types.ConnectionState.Init) {
            content = <div>Loading messages...</div>;
        } else if(this.state.connection.connectionState === Types.ConnectionState.Error) {
            content = <h2 style={{margin:"10px"}}>Error while loading messages.</h2>;
        } else if(this.state.connection.connectionState === Types.ConnectionState.NotAuthorized) {
            content = <h2 style={{margin:"10px"}}>You cannot view messages in this document</h2>;
        } else {
            const documentUrl = "/documents/" + this.state.documentId;
            content =
                <React.Fragment>
                    <div className="users-container">
                        <div className="document_title"><a target="_blank" href={documentUrl}>{this.state.documentTitle}</a></div>
                        <Users currentUser={this.state.currentUser}
                               users={this.state.users}
                               messages={this.state.messages}
                        />
                    </div>                    
                    <div className="messages-container">
                        <Messages
                            messages={this.state.messages}
                            currentUser={this.state.currentUser}
                            users={this.state.users}
                            deleteMessage={(messageId) => this.deleteMessage(messageId)}
                        />
                        <Input
                            onSendMessage={this.onSendMessage}
                        />
                    </div>
                </React.Fragment>
        }
        return (
            <div className="App">
                {content}
            </div>
        );
    }
    reconnect() {
        console.log('reconnecting');
        this.state.connection.connectionId = null;
        this.state.connection.connectionState = Types.ConnectionState.Reconnecting;
        setTimeout(() => {
            const socket = new WebSocket(wsUrl);
            if(socket) {            
                initializeWebsocketConnection(socket,this);
            } else {
                console.log("Cannot create WebSocket.")
            }
        },1000);
    }
    onSendMessage = (message:string) => {
        const newTextMessage = {
            type: "NewTextMessageSent",
            text: message,
            documentId: this.state.documentId,
            id: this.state.connection.connectionId
        };
        if(this.state.connection.socket && message) {
            try {
                this.state.connection.socket.send(JSON.stringify(newTextMessage));
            } catch (error) {
                console.log(error);
            }
        }
    }
}

export default App;
